/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/**
 * NOTE: This hook is used by ui-widget. We will need to check ui-widget whenever we do a change here
 */
import { useEffect, useRef } from 'react';

function useInterval(callback, delay) {
    const savedCallback = useRef();

    useEffect(() => {
        savedCallback.current = callback;
    });

    useEffect(() => {
        function tick() {
            savedCallback.current();
        }

        const id = setInterval(tick, delay);
        return () => clearInterval(id);
    }, [delay]);
}

export default useInterval;
